import axios from 'axios'
import Vue from 'vue'

export async function fetchHistorico(context,payload){
    try{
        context.commit('setLoading',true,{root:true}) //activar loading
        let url = "api/gethistorico" //direccion de la api
        let response = await Vue.axios({
            method: 'GET',
            url: url
        })
        context.commit('setHistorico',response.data)
    }catch(error){  
        context.commit('preprensaError',error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function fetchOrdenes(context,payload){
    try{
        let url = "api/getprepresa"//la direccion de la api
       
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
    
        let response = await Vue.axios({
            method: 'GET',
            url: url
        })
             
        context.commit('setOrdenes',response.data.data)
      
        }catch(error){
            context.commit('preprensaError', error)
        }
        finally{
            context.commit('setLoading',false,{root:true})
        }
}

export async function cerrarOrden(context, payload){
    try{
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        let url = "api/preprensacerrar"//direccion de la api
        let values = new FormData()
        values.append('id',payload.id)
        values.append('comentario',payload.comentario)      
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        context.commit('setIsOk', true);//si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.dispatch('fetchOrdenes')
    }catch(error){
        context.commit('preprensaError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}

export async function comentario(context,payload){
    try{
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        context.commit('setIsOk', false); //seteamos la respuesta en falso
        let url = "api/preprensacomentario"//direccion de la api
        let values = new FormData()
        values.append('id',payload.id)
        values.append('preprensa',payload.preprensa)      
        await Vue.axios({
            method: 'POST',
            url: url,
            data: values
        })
        context.commit('setIsOk', true);//si todo esta bien  llamamos a la mutacion y la seteamos en true.
        context.dispatch('fetchOrdenes')
    }catch(error){
        context.commit('preprensaError', error)
    }finally{
        context.commit('setLoading',false,{root:true})
    }
}

export async function fetchCSV(context){
    try{
        let url = "api/getprepresacsv"//la direccion de la api
       
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
    
        let response = await Vue.axios({
            method: 'GET',
            url: url
        })
             
        context.commit('setCSV',response.data.data)

    }
    catch(error){
        context.commit('preprensaError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}